<script>
  import { connected }                    from './../stores.js';
  import { walletData }                   from './../stores.js';
  import { priceData }                    from './../stores.js';
  import { sinuLocalContract }            from './../stores.js';
  import { slpLocalContract }             from './../stores.js';
  import { neonPoolLocalContract }        from './../stores.js';
  import { sinuPoolLocalContract }        from './../stores.js';
  import { slpPoolLocalContract }         from './../stores.js';
  import { sinuNeonUniPoolLocalContract } from './../stores.js';
  import { slpPoolLocalContractAddress }  from './../stores.js';

  // <------ Update Wallet and Price ------>
  $: ($connected && updateWallet());
  $: (updatePrice());

  let sleep = ms => new Promise(resolve => setTimeout(resolve, ms));

  // <------  Update Wallet Count ------>


  async function updateWallet() {
    while ($connected) {
      if ($walletData['address']) {
        updateWalletAmount(
          await $sinuLocalContract.balanceOf($walletData['address'])                         || 0, //_sinuAmount
          await $slpLocalContract.balanceOf($walletData['address'])                          || 0, //_slpAmount
          await $neonPoolLocalContract.balanceOf($walletData['address'])                     || 0, //_neonStakedAmount
          await $sinuPoolLocalContract.provider.getBalance($walletData['address'])           || 0, //_sinuStakedAmount
          await $slpPoolLocalContract.balanceOf($walletData['address'])                      || 0, //_slpStakedAmount
          await $sinuLocalContract.provider.getBalance($walletData['address'])               || 0, //_neonAmount
          await $sinuLocalContract.allowance($walletData['address'], window.sinuPoolAddress) || 0, //_sinuApprovedAmount
          await $slpLocalContract.allowance($walletData['address'], window.slpPoolAddress)   || 0, //_slpApprovedAmount
          await $neonPoolLocalContract.earned($walletData['address'])                        || 0, //_neonClaimableAmount
          await $sinuPoolLocalContract.earned($walletData['address'])                        || 0, //_sinuClaimableAmount
          await $slpPoolLocalContract.earned($walletData['address'])                         || 0, //_slpClaimableAmount
        );
      }
      if(!!!window.ethereum.selectedAddress) {
        connected.update((currentConnected) => {
          return currentConnected = false;
        });
      }

      await sleep(2000);
    }
  }

  function updateWalletAmount(_sinuAmount, _slpAmount, _neonStakedAmount, _sinuStakedAmount, _slpStakedAmount, _neonAmount, _sinuApprovedAmount, _slpApprovedAmount, _neonClaimableAmount, _sinuClaimableAmount, _slpClaimableAmount) {
    walletData.update((currentWalletData) => {
      currentWalletData['sinuAmount']             = Number(_sinuAmount)            / 10**window.sinuDecimals;                   //_sinuAmount
      currentWalletData['slpAmount']              = Number(_slpAmount)             / 10**window.sinuDecimals;                   //_slpAmount
      currentWalletData['neonStakedAmount']       = Number(_neonStakedAmount)      / 10**window.sinuDecimals;                   //_neonStakedAmount
      currentWalletData['sinuStakedAmount']       = Number(_sinuStakedAmount)      / 10**window.sinuDecimals;                   //_sinuStakedAmount
      currentWalletData['slpStakedAmount']        = Number(_slpStakedAmount)       / 10**window.sinuDecimals;                   //_slpStakedAmount
      currentWalletData['neonAmount']             = Number(_neonAmount)            / 10**window.sinuDecimals;                   //_neonAmount
      currentWalletData['sinuApprovedAmount']     = Number(_sinuApprovedAmount);                                                //_sinuApprovedAmount
      currentWalletData['slpApprovedAmount']      = Number(_slpApprovedAmount);                                                 //_slpApprovedAmount
      currentWalletData['neonClaimableAmount']    = Math.trunc(parseInt(_neonClaimableAmount) / 10**window.sinuDecimals);       //_neonClaimableAmount
      currentWalletData['sinuClaimableAmount']    = Math.trunc(parseInt(_sinuClaimableAmount) / 10**window.sinuDecimals);       //_sinuClaimableAmount
      currentWalletData['slpClaimableAmount']     = Math.trunc(parseInt(_slpClaimableAmount)  / 10**window.sinuDecimals);       //_slpClaimableAmount

      return currentWalletData;
    });

  }

  // <------  Update Wallet Price ------>
  async function updatePrice() {

    var neonPriceInUsd        = (await $sinuNeonUniPoolLocalContract.getAmountsOut(BigInt(10**18), [window.wethAddress, window.usdtAddress]))[1]/10**18;
    var neonPoolRawVL         = (await $neonPoolLocalContract.provider.getBalance($neonPoolLocalContract.address))/10**18;
    var slpPoolRawVL          = (await $sinuLocalContract.balanceOf($slpPoolLocalContractAddress))/10**18;
    var sinuPoolRawVL         = (await $sinuLocalContract.balanceOf($sinuPoolLocalContract.address))/10**18;
 
    var neonPoolTVL           = parseInt((neonPoolRawVL*neonPriceInUsd)+(slpPoolRawVL*2*neonPriceInUsd)+(neonPoolRawVL*sinuPoolRawVL));

    var sinuPriceInNeon = ((await $sinuNeonUniPoolLocalContract.getAmountsOut(BigInt(10**18), [window.sinuAddress, window.wethAddress]))[1]/10**18)
    var sinuPrice       = sinuPriceInNeon*neonPriceInUsd;

    while (true) {
      updateWalletPrice(
        // marketcap
        sinuPrice*1000000,
        // TVL
        neonPoolTVL,   
        // Sinu Price In Neon       
        sinuPriceInNeon,
        // Sinu Price
        sinuPrice
      );

      await sleep(2000);
    }
  }

  function updateWalletPrice(_marketCap, _totalValueLocked, _sinuPriceInEth, _ethPrice) {
    priceData.update((currentWalletPrice) => {
      currentWalletPrice['marketCap']        = _marketCap;
      currentWalletPrice['totalValueLocked'] = _totalValueLocked;
      currentWalletPrice['sinuPrice']        = _ethPrice;

      return currentWalletPrice;
    });
  }
</script>